import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { time } = ids || {};
export const StyledNavigationBar = styled.div `
  display: Flex;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #fff;
`;
export const StyledTitleContainer = styled.div `
  margin-left: 24px;
`;
export const StyledIconContainer = styled.div `
  margin-left: auto;
`;
export const StyledNavigationBarContainer = styled.div `
  display: block;
`;
export const StyledDividerContainer = styled.div `
  position: sticky;
  top: 48px;
`;
export const StyledFadeinOut = styled.div `
  animation: fadeIn ease
    ${time.productive.moderate.ids_time_productive_moderate};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
//# sourceMappingURL=NavigationBar.styles.js.map